import React, { useState, useEffect, Component } from 'react';
import firestore from 'firebase/firebase-firestore';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { Container, Avatar, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Table, TableContainer, Button, TableHead, TableRow, TableBody, TableCell,IconButton} from '@material-ui/core';

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    },
    cardGrid: {
      paddingLeft: "5em"
  
   },
   homeIcon: {
      width: 20,
      height: 20,
      marginRight: "4px"
   },
   link: {
      display: "flex",
   },
   gridTextField: {
      marginTop: "2em"
   },
   card: {
      height: "100%",
      display: "flex",
      flexDirection:"column"
   },
   cardMedia: {
      paddingTop: "56.25%"
   },
   cardContent: {
      flexGrow: 1
   },
   tablecontainer: {
      margin: "auto"
   },
   paper: {
      marginTop: "2em",
      paddingTop: "1em",
      paddingBottom: "2em",
      alignContent: "center",
      width: "100%"
   },
   avatarRestaurant: {
      width: 100,
      height: 100,
      paddingLeft: '6%',
   }
});

class GetData extends Component {

    render(){
        return(
            <div id={this.props.printableId}>
                <h1>IM GUNNA PRINT</h1>
            </div>
        )
    }
    
}

export default GetData;